<template>
  <div class="flex flex-col items-center flex-grow p-4 text-center text-gray-500 gap-0">
    <FontAwesomeIcon class="w-16 h-16 m-6 text-gray-600" icon="circle-xmark" size="3x" />
    <slot name="title">
      <h3 class="m-0 text-xl font-light">Sorry!</h3>
    </slot>
    <slot>
      <p class="m-0">No slides were found.</p>
      <p class="m-0">Please try some other keywords.</p>
    </slot>
  </div>
</template>
